import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled.div`
  width: 100%;
  text-decoration: none;
  justify-content: center;
  align-items: center;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  flex-direction: row;
`

export const FieldGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ values, index }) => {
    const paymentMethod = values.payments[index]?.paymentMethod?.value.codename
    let columnTemplate = ''

    switch (paymentMethod) {
      // método, maquininha, bandeira, [modalidade], valor
      case 'credit_card': columnTemplate = '250px 1fr 1fr 1.4fr 130px'; break
      case 'debit_card': columnTemplate = '250px 1fr 1fr 130px'; break
      case 'voucher':
      case 'courtesy':
      case 'pix':
      case 'transfer':
      case 'billet':
      case 'exchange': columnTemplate = '250px 440px 120px'; break
      default: columnTemplate = '250px 120px'
    }

    return columnTemplate
  }};
  column-gap: 10px;
  align-items: flex-end;
`

export const FormField = styled(Container)`
  justify-content: flex-end;
  padding: 0px;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 3px;

  &:hover {
    cursor: pointer;
  }
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  margin-bottom: 3px;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`
